import type { PricingList, Product } from '@micro-apps/stores';

export type ExperienceDetailsSource = {
	allProducts?: Product[];
	fetching?: boolean;
};

// Only the tile row (IconCardRow) is sourced from the availability store. The
// "Things To Know" blocks and cancellation policy stay authored content and are
// always read from props in experience-details-list.tsx.
export type LiveDetails = {
	price?: number;
	complimentary?: boolean;
	durationTag?: string;
	timeOfDay?: string;
	availability?: string;
	pricingList?: PricingList;
	pricingListDisclaimer?: string;
};

const text = (value?: string) => (typeof value === 'string' ? value.trim() : '');

export function findProduct(
	store: ExperienceDetailsSource | undefined,
	productId: string | undefined
): Product | undefined {
	if (!store || !productId) return undefined;
	return store.allProducts?.find(product => product.id === productId);
}

export function isAwaitingDetails(
	store: ExperienceDetailsSource | undefined,
	productId: string | undefined
): boolean {
	if (!store || !productId) return false;
	if (store.fetching) return true;
	return !store.allProducts?.length;
}

export function detailsFromStore(product: Product): LiveDetails {
	const price = product.summaries?.price;
	const amount = price?.from?.amount;

	return {
		price: Number.isFinite(amount) ? amount : undefined,
		complimentary: price?.complimentary,
		durationTag: text(product.summaries?.durationTag) || undefined,
		timeOfDay: text(product.summaries?.timeOfDay?.text) || undefined,
		availability: text(product.summaries?.timeOfYear?.text) || undefined,
		pricingList: price?.pricingList?.length ? price.pricingList : undefined,
		pricingListDisclaimer: text(product.pricingListDisclaimer ?? undefined) || undefined,
	};
}
